import React from "react";
import { Link } from "react-router-dom";
import "./moreInfo.css";

const MoreInfo = () => {
  return (
    <section className="info">
      <div className="info__container">
        <div className="info__content">
          <h2 className="info__title">M. Ramzy Syahputra</h2>
          <p className="info__role">Informatics Student & Web Enthusiast</p>
          
          <div className="info__details">
            <div className="info__group">
              <h3>Focus</h3>
              <p>Web development, sistem pendukung keputusan, desain digital, dan pengembangan project kreatif berbasis teknologi.</p>
            </div>
            
            <div className="info__group">
              <h3>Currently Learning</h3>
              <p>React Native, Advanced UI/UX, and Modern Backend Systems.</p>
            </div>
            
            <div className="info__group">
              <h3>Interests</h3>
              <p>Music, creative digital projects, quiet aesthetics, and exploring new technologies.</p>
            </div>
          </div>
          
          <div className="info__action">
            <Link to="/" className="info__btn-back">
              <i className="uil uil-arrow-left"></i> Back to Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MoreInfo;